import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { sanitizeString } from '../../utils/sanitizeString';
import './Pill.scss';

const Pill = ({
  className,
  item,
  iconPosition,
  onClick,
}) => {
  const sanitizedLabelHtml = sanitizeString(item.labelHtml);

  const renderIcon = (icon, position) => {
    if (icon) {
      return <span className={`Pill__icon-container ${position}`}>{icon}</span>;
    }
    return null;
  };

  const span = (
    item.labelHtml
    /* eslint-disable-next-line react/no-danger */
      ? <span className="Pill__label" dangerouslySetInnerHTML={{ __html: sanitizedLabelHtml }} />
      : <span className="Pill__label">{item.labelText}</span>
  );

  const handleKeyPress = (e) => {
    if (item.isDisabled) {
      return;
    }

    /** If key is enter key, then click button */
    if (e.key === 'Enter') {
      onClick(item);
    }

    /** If key is esc, only click if selected. */
    if (e.key === 'Escape') {
      if (item.isSelected) {
        onClick(item);
      }
    }
  };

  return (
    <div
      className={cx('Pill', className, {
        'Pill--selected': item.isSelected,
        'Pill--disabled': item.isDisabled,
      })}
      role="checkbox"
      aria-checked={item.isSelected}
      tabIndex="0"
      onClick={() => onClick(item)}
      onKeyPress={handleKeyPress}
    >
      {renderIcon(item.icon, iconPosition)}
      {span}
    </div>

  );
};

Pill.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    icon: PropTypes.node,
    isDisabled: PropTypes.bool,
    isSelected: PropTypes.bool,
    labelText: PropTypes.string,
    labelHtml: PropTypes.string,
  }).isRequired,
  iconPosition: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

Pill.defaultProps = {
  className: undefined,
  iconPosition: 'left',
};

export default Pill;
